import styled from 'styled-components';

import media from '~/utils/media';

import radio from '~/components/styled/radio';

 export const Wrap = styled.div`
  width: 100%;
  border: 1px solid #f2f2f2;
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
  position: relative;

  > img {
    width: 100%;
    margin-top: 10%;
  }
`;

export const FormWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px;

  ${media.pcLarge`
    padding: 40px;
  `}

  ${media.tabletLarge`
    padding: 40px;
  `}

  ${media.tabletSmall`
    padding: 25px;
  `}

  ${media.mobileLarge`
    padding: 25px;
  `}

  ${media.mobileMid`
    padding: 25px;
  `}

  ${media.mobileSmall`
    padding: 20px;
  `}

  > p.title {
    /* font-family: HGGGothicssiP80g; */
    letter-spacing: -2.3px;
    color: #9bbcdb;

    ${media.pcLarge`
      font-size: 33px;
    `}

    ${media.tabletLarge`
      font-size: 33px;
    `}

    ${media.tabletSmall`
      font-size: 20px;
    `}

    ${media.mobileLarge`
      font-size: 20px;
    `}

    ${media.mobileMid`
      font-size: 20px;
    `}

    ${media.mobileSmall`
      font-size: 20px;
    `}
  }
`;

export const Box = styled.div`
  margin-top: 5%;
  padding: 24px 40px 60px;
  box-shadow: 0 5px 30px 0 rgba(0, 0, 0, 0.5);
  background-color: #e8e8e8;

  > p.title {
    /* font-family: HGGGothicssiP60g; */
    font-size: 16px;
    letter-spacing: -1.14px;
    color: #222;
  }

  > ul {
    width: 100%;
    margin-top: 3%;
    padding-bottom: 5%;
    border-bottom: 1px solid #222;

    > li {
      padding-left: 14px;
      /* font-family: HGGGothicssiP40g; */
      font-size: 16px;
      line-height: 20px;
      color: #222222;
      letter-spacing: -1.14px;
      position: relative;

      ${media.pcLarge`
        font-size: 16px;
      `}

      ${media.tabletLarge`
        font-size: 16px;
      `}

      ${media.tabletSmall`
        font-size: 14px;
      `}

      ${media.mobileLarge`
        font-size: 12px;
      `}

      ${media.mobileMid`
        font-size: 12px;
      `}

      ${media.mobileSmall`
        font-size: 12px;
      `}

      > span.idx {
        position: absolute;
        top: 0px;
        left: 0px;
      }

      > span.title {
        /* font-family: HGGGothicssiP60g; */
        font-weight: 600;
      }

      & + li {
        margin-top: 2%;
      }
    }
  }
`;

export const CheckWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 5%;
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  /* font-family: HGGGothicssiP60g; */
  font-weight: 600;
  letter-spacing: 1px;
  cursor: pointer;

  > p {
    font-weight: 500;
  }

  ${media.pcLarge`
    height: 35px;
    margin-top: 13px;
    font-size: 16px;

    & + & {
      margin-left: 5%;
  }
  `}

  ${media.tabletLarge`
    margin-top: 14px;
    font-size: 14px;
    
    & + & {
      margin-left: 5%;
    }
  `}

  ${media.tabletSmall`
    margin-top: 14px;
    font-size: 13px;

    & + & {
      margin-left: 5%;
    }
  `}

  ${media.mobileLarge`
    margin-top: 13px;
    font-size: 11px;

    & + & {
      margin-left: 5%;
    }
  `}

  ${media.mobileMid`
    margin-top: 12px;
    font-size: 11px;

    & + & {
      margin-left: 5%;
    }
  `}

  ${media.mobileSmall`
    margin-top: 12px;
    font-size: 11px;

    & + & {
      margin-left: 5%;
  `}
`;

export const Radio = styled.input.attrs({
  type: 'radio',
})`
  ${radio};
  background-color: #e8e8e8;
  flex: none;
  width: 16px;
  height: 16px;
  margin-left: 8px; 
`;

export const InputWrap = styled.div`
  display: flex;

  > p.title {
    width: 25%;
    padding-top: 2%;
    /* font-family: HGGGothicssiP80g; */
    letter-spacing: -1.84px;
    color: #326cf9;

    ${media.pcLarge`
      font-size: 24px;
    `}

    ${media.tabletLarge`
      font-size: 24px;
    `}

    ${media.tabletSmall`
      font-size: 18px;
    `}

    ${media.mobileLarge`
      font-size: 18px;
    `}

    ${media.mobileMid`
      font-size: 18px;
    `}

    ${media.mobileSmall`
      font-size: 18px;
    `}
  }

  > div.text-field {
    display: flex;
    flex-direction: column;
    width: 75%;

    > input {
      border: 0;
      background-color: #fff;
      padding: 0 5%;

      ${media.pcLarge`
        width: 220px;
        height: 40px;
        font-size: 18px;
      `}

      ${media.tabletLarge`
        width: 220px;
        height: 40px;
        font-size: 18px;
      `}

      ${media.tabletSmall`
        width: 220px;
        height: 35px;
        font-size: 18px;
      `}

      ${media.mobileLarge`
        width: 120px;
        height: 28px;
        font-size: 14px;
      `}

      ${media.mobileMid`
        width: 120px;
        height: 28px;
        font-size: 14px;
      `}

      ${media.mobileSmall`
        width: 120px;
        height: 28px;
        font-size: 14px;
      `}
    }

    > p.black {
      margin-top: 3%;
      /* font-family: HGGGothicssiP60g; */
      letter-spacing: -1.16px;
      color: #222;

      ${media.pcLarge`
        font-size: 18px;
      `}

      ${media.tabletLarge`
        font-size: 18px;
      `}

      ${media.tabletSmall`
        font-size: 14px;
      `}

      ${media.mobileLarge`
        font-size: 12px;
      `}

      ${media.mobileMid`
        font-size: 12px;
      `}

      ${media.mobileSmall`
        font-size: 12px;
      `}
    }

    > p.red {
      margin-top: 3%;
      /* font-family: HGGGothicssiP40g; */
      line-height: 1.2;
      letter-spacing: -1px;
      color: #f2163b;

      ${media.pcLarge`
        font-size: 14px;
      `}

      ${media.tabletLarge`
        font-size: 14px;
      `}

      ${media.tabletSmall`
        font-size: 12px;
      `}

      ${media.mobileLarge`
        font-size: 11px;
      `}

      ${media.mobileMid`
        font-size: 11px;
      `}

      ${media.mobileSmall`
        font-size: 11px;
      `}
    }
  }

  & + div {
    margin-top: 5%;
  }
`;

export const BtnWrap = styled.div`
  margin-top: 5%;
  text-align: center;
`;

export const Button = styled.button`
  padding: 20px 84px;
  color: #fff;
  border: 0;
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.5);
  background-color: #326cf9;

  > p.bold {
    /* font-family: HGGGothicssiP80g; */
    font-weight: 700;
    letter-spacing: -1px;
  }

  > p.normal {
    /* font-family: HGGGothicssiP60g; */
    letter-spacing: -0.5px;
  }

  ${media.pcLarge`
    > p.bold {
      font-size: 30px;
    }

    > p.normal {
      font-size: 13px;
    }
  `}

  ${media.tabletLarge`
  > p.bold {
      font-size: 30px;
    }

    > p.normal {
      font-size: 13px;
    }
  `}

  ${media.tabletSmall`
    > p.bold {
      font-size: 30px;
    }

    > p.normal {
      font-size: 13px;
    }
  `}

  ${media.mobileLarge`
    > p.bold {
      font-size: 24px;
    }

    > p.normal {
      font-size: 12px;
    }
  `}

  ${media.mobileMid`
    > p.bold {
      font-size: 24px;
    }

    > p.normal {
      font-size: 12px;
    }
  `}

  ${media.mobileSmall`
    > p.bold {
      font-size: 24px;
    }

    > p.normal {
      font-size: 12px;
    }
  `}
`;
